import affaire from './../assets/affaire.jpg';
import civil from './../assets/civil.jpg';
import finance from './../assets/finance.jpg';
import commerce from './../assets/commerce.jpg';

export const imgItems = [
    {
      id: 1,
      image: affaire,
    },
    {
      id: 2,
      image: finance,
    },
    {
      id: 3,
      image: civil,
    },
    {
      id: 4,
      image: commerce,
    }
  ]